import { render, staticRenderFns } from "./datosInmuebles.vue?vue&type=template&id=5914c39f&scoped=true"
import script from "./datosInmuebles.vue?vue&type=script&lang=js"
export * from "./datosInmuebles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914c39f",
  null
  
)

export default component.exports